export default __webpack_public_path__ + "static/media/aiFaceInActive.d1b9aa1c.svg";